import { render, staticRenderFns } from "./AdminViewSystem.vue?vue&type=template&id=8e97bdb4&"
import script from "./AdminViewSystem.vue?vue&type=script&lang=ts&"
export * from "./AdminViewSystem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports